import Vue from "vue";

const STORAGE_KEY = "hb-transformer-locale";
const SEO_CONTENT = {
  "zh-CN": {
    htmlLang: "zh-CN",
    title: "江苏宏邦变压器有限公司-整体输配电解决方案",
    description:
      "干式变压器，油浸式变压器，电力变压器，箱式变电站，高低压成套设备，隔离变压器，特种变压器..."
  },
  "en-US": {
    htmlLang: "en",
    title: "Jiangsu Hongbang Transformer Co., Ltd. - Transformer Manufacturer",
    description:
      "Dry-Type Transformers, Oil-Immersed Transformers, Power Transformers, Prefabricated Substations, High & Low Voltage Switchgear, Isolation Transformers, Special Transformers, and More..."
  }
};
const CHINA_TIMEZONES = new Set([
  "Asia/Shanghai",
  "Asia/Chongqing",
  "Asia/Harbin",
  "Asia/Urumqi",
  "Asia/Hong_Kong",
  "Asia/Macau",
  "Asia/Taipei"
]);

function detectDefaultLocale() {
  const savedLocale = window.localStorage.getItem(STORAGE_KEY);
  if (savedLocale) {
    return savedLocale;
  }

  const languages = navigator.languages && navigator.languages.length ? navigator.languages : [navigator.language];
  const hasChineseLanguage = languages.some((language) => /^zh\b/i.test(language || ""));
  if (hasChineseLanguage) {
    return "zh-CN";
  }

  const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  if (CHINA_TIMEZONES.has(timeZone)) {
    return "zh-CN";
  }

  return "en-US";
}

function updateDocumentMeta(locale) {
  if (typeof document === "undefined") {
    return;
  }

  const seo = SEO_CONTENT[locale] || SEO_CONTENT["zh-CN"];
  document.title = seo.title;

  const descriptionMeta = document.querySelector('meta[name="description"]');
  if (descriptionMeta) {
    descriptionMeta.setAttribute("content", seo.description);
  }

  if (document.documentElement) {
    document.documentElement.setAttribute("lang", seo.htmlLang);
  }
}

export const i18nState = Vue.observable({
  locale: detectDefaultLocale()
});

export function setLocale(locale) {
  i18nState.locale = locale;
  window.localStorage.setItem(STORAGE_KEY, locale);
  updateDocumentMeta(locale);
}

export function pick(value, locale = i18nState.locale) {
  if (value && typeof value === "object" && !Array.isArray(value)) {
    return value[locale] || value["zh-CN"] || "";
  }
  return value;
}

export function mapLocalizedList(items, locale = i18nState.locale) {
  return (items || []).map((item) => {
    if (typeof item === "string") {
      return item;
    }

    const mapped = {};
    Object.keys(item).forEach((key) => {
      mapped[key] = pick(item[key], locale);
    });
    return mapped;
  });
}

export default {
  computed: {
    locale() {
      return i18nState.locale;
    }
  },
  methods: {
    $pick(value) {
      return pick(value, i18nState.locale);
    },
    $setLocale(locale) {
      setLocale(locale);
    },
    $mapLocalizedList(items) {
      return mapLocalizedList(items, i18nState.locale);
    }
  }
};

if (typeof window !== "undefined") {
  updateDocumentMeta(i18nState.locale);
}
